export default __webpack_public_path__ + "static/media/list_of_items.1fad19d1.png";